// TODO: To move to frontend-libs if solution will be useful
import { useCallback } from "react";
import ReactDOM from "react-dom";
export const usePortal = () => {
    const portalContainer = document.getElementById("site-react-portal-root");
    const renderPortal = useCallback((content) => {
        if (!portalContainer) {
            console.error("Portal container element not found");
            return null;
        }
        return ReactDOM.createPortal(content, portalContainer);
    }, [portalContainer]);
    return { renderPortal };
};
//# sourceMappingURL=usePortal.js.map